"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecurities = void 0;
const lodash_1 = require("lodash");
const guards_1 = require("./guards");
function getSecurities(document, operationSecurities) {
    var _a;
    const definitions = (_a = document.components) === null || _a === void 0 ? void 0 : _a.securitySchemes;
    if (!lodash_1.isObject(definitions))
        return [];
    return (operationSecurities || document.security || []).map(operationSecurity => {
        return Object.entries(operationSecurity)
            .map(([opScheme, scopes]) => {
            const definition = definitions[opScheme];
            if (guards_1.isSecurityScheme(definition) && definition.type === 'oauth2') {
                return Object.assign(Object.assign({}, definition), { flows: lodash_1.mapValues(definition.flows, (flow) => (Object.assign(Object.assign({}, flow), { scopes: lodash_1.pickBy(flow.scopes, (_val, key) => scopes === null || scopes === void 0 ? void 0 : scopes.includes(key)) }))), key: opScheme });
            }
            return Object.assign(Object.assign({}, definition), { key: opScheme });
        })
            .filter(guards_1.isSecuritySchemeWithKey);
    });
}
exports.getSecurities = getSecurities;
//# sourceMappingURL=accessors.js.map